import { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import useUserStore from "../../../utils/storeApp";
import { Column } from "primereact/column";
import CallAPI from "../../../services/apiCalls";
import { Tag } from "primereact/tag";
import $ from "jquery";
import { useReactToPrint } from "react-to-print";

const ListDownloadStatus = () => {
  const { userRole, userToken, SetSharedObject } = useUserStore((state) => ({
    userRole: state.userRole,
    userToken: state.userToken,
    SetSharedObject: state.SetSharedObject,
  }));
  const [processing, SetProcessing] = useState(false);
  const [reportObj, setReportObj] = useState([]);
  const [cmfFlag, SetCmfFlag] = useState(false);
  const [errMsg, SetErrMsg] = useState(false);
  const [processingDelete, setprocessingDelete] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [sortField, setSortField] = useState("requestDate");
  const [sortOrder, setSortOrder] = useState(-1); // 1 for ascending, -1 for descending
  const [first, setFirst] = useState(0); // Initial first record index
  const [rows, setRows] = useState(25); // Number of rows per page
  const [totalRecords, setTotalRecords] = useState(0);
  const firstFocusRef = useRef(null);

  useEffect(() => {
    const modalEl = document.getElementById("comfirmDelete");
    if (!modalEl) return;
    const onShown = () => setTimeout(() => firstFocusRef.current?.focus(), 50);
    modalEl.addEventListener("shown.bs.modal", onShown);
    return () => modalEl.removeEventListener("shown.bs.modal", onShown);
  }, []);

  const userActions = (row, type) => {
    SetCmfFlag(false);
    if (type === "Download") {
      openAttachment(row.s3DownLoadUrl);
    } else if (type === "Delete") {
      setSelectedProduct([row]);
      //row.reportId
      DeleteEmailComfirm();
    }
  };

  const DeleteEmailComfirm = () => {
    if (selectedProduct.length === 0) {
      SetCmfFlag(true);
    }
    $("#comfirmDelete").modal("show");
  };

  const multiDelete = async () => {
    for (let row of selectedProduct) {
      await deleteReports(row.reportId, true);
    }
    CloseModal();
    getReports();
  };

  const openAttachment = async (url) => {
    if (!url) return;
    // Create a hidden anchor and trigger download
    const link = document.createElement("a");
    link.href = url;
    link.download = ""; // Let browser infer filename
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const deleteReports = async (id, flag) => {
    setReportObj([]);
    setprocessingDelete(true);
    let call = "/reports/DeleteReportRequest?reportId=" + id;
    const res = await CallAPI(call, false, "get", userToken);
    SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      setprocessingDelete(false);
      if (!flag) getReports();
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      if (Object.keys(msg).length > 0 && msg.constructor === Object) {
        let str = "<div>";
        for (let el in msg) {
          str += `${el}`;
        }
        str += "</div>";
        SetErrMsg(str);
      } else {
        SetErrMsg(msg);
      }
    }
  };

  useEffect(() => {
    getReports();
  }, [sortField, sortOrder, first, rows]);

  const getReports = async () => {
    SetErrMsg(false);
    setSelectedProduct([]);
    setReportObj([]);
    SetProcessing(true);

    const sortDir = sortOrder === 1 ? "ASC" : "DESC";
    const page = Math.ceil((first + 1) / rows);

    let currentSortField = sortField;
    if (currentSortField === "RType") {
      currentSortField = "ReportType";
    } else if (currentSortField == "DownloadStatus") {
      currentSortField = "ReportStatus";
    } else if (currentSortField == "fullNameDisplay") {
      currentSortField = "UserName";
    }

    let call =
      "/reports/GetReportsStatus?page=" +
      page +
      "&pageSize=" +
      rows +
      "&sortBy=" +
      currentSortField +
      "&sortDir=" +
      sortDir;
    const res = await CallAPI(call, false, "get", userToken);

    SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      setTotalRecords(res.data.data.count);
      ReportsGrid(res.data.data.pageItems);

      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(false);
    }
  };

  const ReportsGrid = (obj) => {
    let tempObj = [];
    //let opt = ["Download", "Delete"]; -- not being used 
    for (const row of obj) {
      let show = row.reportStatus !== "Ready" ? 0 : 1;
      row.RType = row.reportTypeName.replaceAll("1", " ");
      let select = (
        <span>
          {/* row.reportStatus === "Ready" ? */}
          <button
            type="button"
            className={`btn btn-outline-secondary btn-sm ${row.reportStatus !== "Ready" ? "disabled" : ""}`}
            style={{ minWidth: "25px", border: "none", opacity: show }}
            aria-label={
              row.reportStatus !== "Ready"
                ? `Download ${row.fileName} (not ready)`
                : `Download ${row.fileName}`
            }
            aria-hidden={row.reportStatus !== "Ready" ? "true" : undefined}
            disabled={row.reportStatus !== "Ready"}
            onClick={(e) => {
              if (row.reportStatus === "Ready") userActions(row, "Download");
            }}
          >
            <i className="bi bi-download" aria-hidden="true"></i>
          </button>
          {/* :null} */}
          <button
            type="button"
            onClick={(e) => userActions(row, "Delete")}
            className="btn btn-outline-danger btn-sm ml-1"
            style={{ minWidth: "25px", border: "none" }}
            aria-label={`Delete ${row.fileName || "this file"}`}
          >
            <i className="bi bi-trash" aria-hidden="true"></i>
          </button>
        </span>
      );
      row.Actions = select;
      if (row.reportStatus === "Failed") {
        let status = (
          <Tag
            severity={"danger"}
            role="button"
            aria-label="Failed - click for details"
            aria-haspopup="dialog"
            tabIndex={0}
            onClick={(el) => {
              $("#FailedReportModal").modal("show");
            }}
          >
            Failed <i className="bi bi-exclamation-triangle-fill" aria-hidden="true"></i>
          </Tag>
        );
        row.DownloadStatus = status;
      } else if (row.reportStatus === "Ready") {
        let s = <Tag severity={"success"} aria-label="Status: Ready">Ready</Tag>;
        row.DownloadStatus = s;
      } else {
        let d = <Tag severity={"warning"} aria-label="Status: In Progress">In Progress</Tag>;
        row.DownloadStatus = d;
      }
      let dName = JSON.parse(row?.reportParameters)?.DomainName;
      row.DomainName = dName;
      tempObj.push(row);
    }
    setReportObj(tempObj);
  };

  const formatSentDate = (dt) => {
    return dt.requestDate
      ? new Date(dt.requestDate).toLocaleString("en-US", { hour12: false })
      : null;
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const refreshPage = () => {
    getReports();
  };

  const handleColumnSort = (event) => {
    setSortField(event.sortField);
    setSortOrder(event.sortOrder);
  };

  const handlePageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const [loadingText, setLoadingText] = useState("Loading...");
  useEffect(() => {
  let timer;
  if (processing) {
    timer = setTimeout(() => {
      setLoadingText("Working on it...");
    }, 10000);
  } else {
    setLoadingText("Loading...");
  }

  return () => clearTimeout(timer); 
}, [processing]);

    const CloseModal = () => {
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
        $('#comfirmDelete').modal('hide');
    };

  return (
    <main className="ListDownloadStatus" ref={componentRef} >
        <header className="HeaderDownloadStatusTool">
          <h4 className="title-label3">
            <span className="spacer-margin2">Download Status</span>
          </h4>
          <div className="mid-header-bar spacer-inline">
            <span className="SharedTools" role="group" aria-label="Export and print tools">
              <button
                className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                aria-label={
                totalRecords === 0
                  ? "Refresh report (no results)"
                  : "Refresh report"
                }
                disabled={totalRecords === 0}
                aria-disabled={totalRecords === 0}
                onClick={(e) => {
                  if (totalRecords > 0) refreshPage();
                }}
              >
                <i className="bi bi-arrow-clockwise" aria-hidden="true"></i>
              </button>
              <button
                className="btn btn-outline-dark sp-margin5 btn-reports-sm"
                aria-label={
                totalRecords === 0
                  ? "Print report (no results)"
                  : "Print download status report"
                }
                  disabled={totalRecords === 0}
                  aria-disabled={totalRecords === 0}
                onClick={(e) => {
                  if (totalRecords > 0) handlePrint();
                }}
              >
                <i className="bi bi-printer" aria-hidden="true"></i>
              </button>
            </span>
          </div>
        </header>
      <section className="grid-layout">
        <div>
          <DataTable
            value={reportObj}
            aria-label="Download status report"
            paginator
            selectionPageOnly
            lazy
            rowsPerPageOptions={[25, 50, 75]}
            tableStyle={{ minWidth: "50rem" }}
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            dataKey="reportId"
            selectionMode={"checkbox"}
            selection={selectedProduct}
            onSelectionChange={(e) => setSelectedProduct(e.value)}
            columnResizeMode="expand"
            resizableColumns
            scrollable
            first={first}
            rows={rows}
            totalRecords={totalRecords}
            sortField={sortField}
            sortOrder={sortOrder}
            onSort={handleColumnSort}
            onPage={handlePageChange}
          >
            <Column selectionMode="multiple" className="w-s" header={<span className="sr-only">Select rows</span>}></Column>
            <Column
              field="fileName"
              header="File Name"
              className="truncate"
              sortable
            ></Column>
            <Column
              field="requestDate"
              header="Request Date"
              className="w-md8"
              sortable
              body={formatSentDate}
            ></Column>
            <Column
              field="fullNameDisplay"
              header="Started By"
              className="truncate"
              sortable
            ></Column>
            <Column
              field="RType"
              header="Report Type"
              className="w-md7"
              sortable
            ></Column>
            <Column
              field="DownloadStatus"
              header="Status"
              className="w-md1"
              sortable
            ></Column>
            <Column field="Actions" header="Actions" className="w-md1"></Column>
          </DataTable>
          <div className="paging">
            <div className="spacer-inline spacer-margin9">
              <button
                className="btn btn-outline-secondary"
                aria-label={
                  selectedProduct.length === 0
                    ? "Delete selected reports (none selected)"
                    : `Delete ${selectedProduct.length} selected report${selectedProduct.length > 1 ? "s" : ""}`
                }
                onClick={(e) => DeleteEmailComfirm()}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </section>
      {/* <FailedReportView /> */}
      <div
        className="modal fade"
        id="comfirmDelete"
        data-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="deleteConfirmTitle"
      >
        <div className="modal-dialog ">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title" id="deleteConfirmTitle">Delete Confirmation</h3>
              <button
                type="button"
                className="close"
                aria-label="Close delete confirmation modal"
                onClick={CloseModal}
                disabled={processingDelete}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {selectedProduct.length === 0 ? (
                <div className="ctr sp-pad3" role="status" aria-live="polite" aria-atomic="true">
                  There was nothing selected to delete.
                </div>
              ) : (
                <>
                  <div className="field-wrapper">
                    <div className="spacer-margin7 line-s1">
                      <label htmlFor="delete-confirmation">
                        Are you sure you want to delete the reports listed below?
                      </label>
                    </div>
                    <ul className="sp-margin4" id="delete-confirmation">
                      {selectedProduct.map((el) => (
                        <li key={el.reportId}>{el.fileName}</li>
                      ))}
                    </ul>
                  </div>

                  {errMsg ? (
                    <div className="alert alert-danger" role="alert" aria-live="assertive" aria-atomic="true">
                        {errMsg}
                    </div>
                  ) : null}
                </>
              )}
            </div>
            <div className="modal-footer">
              {selectedProduct.length === 0 ? null : (
                <button
                  type="button"
                  ref={firstFocusRef}
                  className="btn btn-success"
                  onClick={(e) => multiDelete()}
                  disabled={processingDelete}
                  aria-disabled={processingDelete}
                  aria-label={processingDelete ? "Deleting, please wait" : "Confirm delete"}
                >
                  {processingDelete ? "Deleting..." : "Confirm"}
                </button>
              )}
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={CloseModal}
                disabled={processingDelete}
              >
                {selectedProduct.length === 0 ? "Close" : "Cancel"}
              </button>
            </div>
          </div>
        </div>
      </div>
      {processing && (
        <div 
            className="loader-container" 
            role="status" 
            aria-live="polite" 
            aria-atomic="true"
            aria-labelledby="download-status-loader"
        >
            <div className="spinner" aria-hidden="true"></div>
            <div className="loading-text" id="download-status-loader">{loadingText}</div>
        </div>
        )}
    </main>
  );
};

export default ListDownloadStatus;
